import React, { useState, useCallback, useEffect } from "react";
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null);

    const closeMenu = useCallback(() => {
        setIsMenuOpen(false);
        setActiveSubmenu(null);
        document.body.classList.remove('h-active');
    }, []);

    const toggleMenu = useCallback(() => {
        const newState = !isMenuOpen;
        setIsMenuOpen(newState);
        
        if (activeSubmenu) {
            setActiveSubmenu(null);
        }
        
        if (newState) {
            document.body.classList.add('h-active');
        } else {
            document.body.classList.remove('h-active');
        }
    }, [isMenuOpen, activeSubmenu]);

    const handleMenuItemClick = useCallback((option, e) => {
        e.preventDefault();

        const isAlreadyActive = activeSubmenu === option;
        
        if (isAlreadyActive) {
            setActiveSubmenu(null);
        } else {
            setActiveSubmenu(option);
        
        }
    }, [activeSubmenu,]);

    useEffect(() => {
        return () => {
            document.body.classList.remove('h-active');
        };
    }, []);
    
    const menuOptions = [
        {
            id: 1,
            title: "Model Finder",
            links: [],
            link: 'https://www.audi.com.mx/es/models/'
        },
        {
            id: 2,
            title: "Promociones",
            links: [],
            link: 'https://www.audi.com.mx/es/experiencia/promocAudi/'
        },
        {
            id: 3,
            title: "Audi Financial Services",
            links: [],
            link: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/'
        },
        {
            id: 4,
            title: "Postventa",
            links: [],
            link: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/'
        },
        {
            id: 5,
            title: "Experiencia",
            links: [
                { href: "https://www.audi.com.mx/es/experiencia/audi_rewards/", text: "Audi rewards" },
                { href: "https://www.appsaudi.com.mx/Lifestyle/collection/home", text: "Audi Collection", external: true },
                { href: "https://www.appsaudi.com.mx/Lifestyle/accesorios/home", text: "Audi Accesorios", external: true },
                { href: "https://www.audi.com.mx/es/experiencia/audi-exclusive/", text: "Audi exclusive" },
                { href: "https://www.audi.com.mx/es/experiencia/temporadas/temporadas_podcast/", text: "Modelando el futuro" },
                { href: "https://audinewsletter.com.mx/?news_year=2019&news_month=09", text: "e-Newsletter" },
                { href: "https://www.audi.com/en.html", text: "Audi internacional" },
                { href: "https://www.audi.com.mx/es/experiencia/go-green/", text: "Audi Go Green" }
            ]
        },
        {
            id: 6,
            title: "Servicios al cliente",
            links: [
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/atencion_a_clientes/", text: "Atención a clientes" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/Audi_Financial_Services/", text: "Audi Financial Services" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/audi_connect/", text: "Audi Connect" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/postventa/", text: "Postventa" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/garantia_extendida/", text: "Garantía extendida" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-revision/", text: "Llamado a revisión general" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-airbag/", text: "Llamado a revisión de bolsas de aire" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/audi_waiting/", text: "Delivery situation" },
                { href: "https://www.audi.com.mx/es/servicios-al-cliente/audi-contigo/", text: "Audi contigo" }
            ]
        },
        {
            id: 7,
            title: "Audi Certified :plus",
            links: [
                { href: "https://www.audi.com.mx/es/certified-plus/certified/", text: "Audi Certified :plus" },
                { href: "https://www.audi.com.mx/es/certified-plus/certified/concesionarios_audi_certified_plus/", text: "Concesionarios Audi Certified :plus" }
            ]
        },
        {
            id: 8,
            title: "Historias de progreso",
            links: [
                { href: "https://www.audi.com.mx/es/historias-de-progreso/", text: "Descripción general" },
                { href: "https://www.audi.com.mx/es/historias-de-progreso/sustentabilidad/", text: "Sustentabilidad" },
                { href: "https://www.audi.com.mx/es/historias-de-progreso/motorsport/", text: "Motorsport" },
                { href: "https://www.audi.com.mx/es/historias-de-progreso/diseno/", text: "Diseño" },
                { href: "https://www.audi.com.mx/es/historias-de-progreso/tecnologia/", text: "Tecnología" },
                { href: "https://www.audi.com.mx/es/historias-de-progreso/lifestyle/", text: "Lifestyle" }
            ]
        },
        {
            id: 9,
            title: "Autos Seminuevos Disponibles",
            links: [],
            link: 'https://www.audi.com.mx/es/certified-plus/'
        },
        {
            id: 10,
            title: "Autos Nuevos Disponibles",
            links: [],
            link: 'https://www.audi.com.mx/es/new-car-search/'
        },
        {
            id: 11,
            title: "Llamado a revisión de bolsas de aire",
            links: [],
            link: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-airbag/'
        },
        {
            id: 12,
            title: "Llamado a revisión general",
            links: [],
            link: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-revision/'
        },
        {
            id: 13,
            title: "Contacto",
            links: [
                { href: "https://www.appsaudi.com.mx/audi-forms/salesforce/audi-nuevo?utm_source=audi&utm_medium=referral&utm_campaign=site_general_form", text: "Quiero comprar un Audi nuevo" },
                { href: "https://www.audi.com.mx/es/models/forms/sugerencia/", text: "Sugerencias y comentarios" },
                { href: "https://www.audi.com.mx/es/models/forms/informacion/", text: "Solicitar información" },
                { href: "https://www.audi.com.mx/es/models/forms/rh/", text: "Recursos humanos" },
                { href: "https://www.audi.com.mx/es/models/forms/quejas/", text: "Quejas" },
                { href: "https://www.audi.com.mx/es/models/forms/otro/", text: "Otros" },
                { href: "https://www.audi.com.mx/es/models/forms/postventa/", text: "Servicios postventa" }
            ]
        }
    ];

    return (
        <div className="nm-header">
            <div className="header-v">
                <div className="h-general header" data-fefa-custom-id="audi-header" data-module="one-header"
                    data-navigation-items-amount="4">
                    <div className={`h-layerM ${activeSubmenu ? 'active' : ''}`} id="layerM" onClick={closeMenu}></div>
                    
                    <div className="h-content">
                        {/* Logo de Audi */}
                        <div className={`module-1 ${isMenuOpen ? 'active' : ''}`} id="h-module-1">
                            <a aria-label="Audi" href="https://www.audi.com.mx/mx.html" title="Audi">
                                <svg height="24" width="69" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M56.927 0a11.798 11.798 0 00-7.495 2.671A11.906 11.906 0 0041.9 0a11.719 11.719 0 00-7.494 2.671C32.347 1.006 29.745 0 26.91 0a11.798 11.798 0 00-7.494 2.671C17.358 1.006 14.756 0 11.92 0 5.32 0 0 5.303 0 11.884c0 6.58 5.32 11.884 11.921 11.884 2.835 0 5.475-1.007 7.495-2.671 2.058 1.664 4.66 2.67 7.494 2.67 2.835 0 5.475-1.006 7.495-2.67a11.906 11.906 0 007.533 2.67c2.874 0 5.475-1.006 7.533-2.67 2.058 1.664 4.66 2.67 7.495 2.67 6.601 0 11.921-5.302 11.921-11.883C68.848 5.342 63.528 0 56.927 0zm-7.495 17.226a9.126 9.126 0 01-1.708-5.342c0-1.974.621-3.832 1.708-5.342a9.126 9.126 0 011.709 5.342c0 2.013-.66 3.832-1.709 5.342zm-15.027 0a9.126 9.126 0 01-1.709-5.342c0-1.974.621-3.832 1.709-5.342a9.126 9.126 0 011.708 5.342c0 2.013-.66 3.832-1.708 5.342zm-15.028 0a9.126 9.126 0 01-1.709-5.342c0-1.974.622-3.832 1.709-5.342a9.126 9.126 0 011.708 5.342c0 2.013-.66 3.832-1.708 5.342zM2.602 11.884c0-5.071 4.116-9.213 9.242-9.213a9.22 9.22 0 015.63 1.897c-1.592 2.013-2.524 4.529-2.524 7.316 0 2.748.932 5.303 2.524 7.316-1.553 1.2-3.495 1.897-5.63 1.897-5.087 0-9.242-4.103-9.242-9.213zM21.24 19.2c1.592-2.013 2.524-4.529 2.524-7.316 0-2.749-.932-5.303-2.524-7.316 1.553-1.2 3.495-1.897 5.63-1.897 2.136 0 4.078.697 5.63 1.897-1.591 2.013-2.523 4.529-2.523 7.316 0 2.748.932 5.303 2.524 7.316-1.553 1.2-3.495 1.897-5.63 1.897-2.136 0-4.078-.697-5.631-1.897zm15.028 0c1.592-2.013 2.524-4.529 2.524-7.316 0-2.749-.932-5.303-2.524-7.316 1.553-1.2 3.494-1.897 5.63-1.897a9.22 9.22 0 015.63 1.897c-1.591 2.013-2.523 4.529-2.523 7.316 0 2.748.932 5.303 2.524 7.316-1.554 1.2-3.495 1.897-5.63 1.897a9.22 9.22 0 01-5.631-1.897zm20.658 1.897a9.22 9.22 0 01-5.63-1.897c1.591-2.013 2.523-4.529 2.523-7.316 0-2.749-.932-5.303-2.524-7.316 1.554-1.2 3.495-1.897 5.63-1.897 5.088 0 9.243 4.103 9.243 9.213 0 5.11-4.155 9.213-9.242 9.213z"
                                        fill="#000" fillRule="evenodd"></path>
                                </svg>
                                <strong>Audi</strong>
                            </a>
                        </div>
                        <div className={`module-1 ${isMenuOpen ? 'active' : ''}`} id="h-module-1">
                        </div>

                        {/* Botón de menú hamburguesa (ahora visible en todas las pantallas) */}
                        <div className="module-2" id="h-module-2">
                            <button aria-label="Menú" onClick={toggleMenu} className="menu-button">
                                <div className="menu-icon">
                                    <div className={`menu-icon__1 ${isMenuOpen ? 'active' : ''}`} id="h-module-2-icon1"></div>
                                    <div className={`menu-icon__2 ${isMenuOpen ? 'active' : ''}`} id="h-module-2-icon2"></div>
                                    <div className={`menu-icon__3 ${isMenuOpen ? 'active' : ''}`} id="h-module-2-icon3"></div>
                                    <div className={`menu-icon__4 ${isMenuOpen ? 'active' : ''}`} id="h-module-2-icon4"></div>
                                </div>
                                <span className="menu-icon__span">Menú</span>
                            </button>
                        </div>

                        {/* Menú principal */}
                        <div className={`module-3 ${isMenuOpen ? 'active' : ''} ${activeSubmenu ? 'sub-active' : ''}`} id="h-module-3">
                            <nav className={`menu__navG ${isMenuOpen ? 'active' : ''}`} id="h-module-3-nav">
                                {menuOptions.map(option => (
                                    <div className="menu__navG--item" key={option.id}>
                                        {option.links.length === 0 && option.link ? (
                                            <a 
                                                id={`option_${option.id}-link`}
                                                className={`menu__navG--item--title`}
                                                href={option.link}
                                                rel="noreferrer"
                                            >
                                                <span>{option.title}</span>
                                            </a>
                                        ) : (
                                            <Link 
                                                id={`option_${option.id}-link`}
                                                className={`menu__navG--item--title ${activeSubmenu === option.id ? 'active' : ''}`}
                                                to="/"
                                                target="_self"
                                                onClick={(e) => handleMenuItemClick(option.id, e)}
                                                rel=""
                                            >
                                                <span>{option.title}</span>

                                                <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
  <path d="M9 6 L15 12 L9 18" />
</svg>
                                            </Link>
                                        )}
                                        
                                        {option.links.length > 0 && (
                                            <div id={`option_${option.id}-module`} className={`menu__navG--item--submenu ${activeSubmenu === option.id ? 'active' : ''}`}>
                                                <div>
                                                    <button 
                                                        className="submenu__btn" 
                                                        onClick={() => handleMenuItemClick(option.id, { preventDefault: () => {} })}
                                                    >
                                                        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
  <path d="M9 6 L15 12 L9 18" />
</svg>
                                                        <span>{option.title}</span>
                                                    </button>
                                                    
                                                    <div className="submenu__content">
                                                        <nav className="submenu__content__nav">
                                                            <ul className="submenu__content__nav--ul">
                                                                {option.links.map((link, index) => (
                                                                    <li className="submenu__content__nav--ul--li" key={index}>
                                                                        <a 
                                                                            className="submenu--link"
                                                                            href={link.href}
                                                                            target={link.external ? "_blank" : "_self"}
                                                                            rel={link.external ? "noreferrer" : ""}
                                                                        >
                                                                            {link.text}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="u-header-nemo-fullwidth-patch"></div>
            </div>
        </div>
    );
};

export default Header;